module.exports = __webpack_public_path__ + "img/sign-56.e3a64575.jpg";